import {ContactPersonCreateReq, ContactPersonDetailRes} from "./user.contract";
import {OpeningTimeCreateReq, OpeningTimeDetailRes} from "./opening-time.contract";
import {NoteDetailRes} from './note/note.contract';
import {Type} from 'class-transformer';
import {TrackerDetailRes} from './tracker/tracker.contract';
import {CompanyDetailsRes, UserDetailsRes} from '../cp';

// TODO: merge with CompanyDetailsRes -> duplicate and also nearly same name
// export class CompanyDetailRes {
//     id!: number;
//     customerNumber!: string;
//
//     @Type(() => ContactPersonDetailRes)
//     contactPerson: ContactPersonDetailRes[] = [];
//
//     companyLogo!: string;
//
//     name!: string;
//
//     timezone!: number;
//
//     @Type(() => OpeningTimeDetailRes)
//     openingTimes: OpeningTimeDetailRes[] = []
//
//     @Type(() => NoteDetailRes)
//     communications: NoteDetailRes[] = []
//
//     @Type(() => TrackerDetailRes)
//     public trackers: TrackerDetailRes[] = []
//
//     @Type(() => UserDetailsRes)
//     public managingDirectors: UserDetailsRes[] = []
//
//     constructor() {
//     }
//

// }

export class CompanyCreateReq {
    name: string = '';
    timezone: number = ((new Date(Date.now()).getTimezoneOffset()) / 60) * -1

    constructor(comp: CompanyDetailsRes) {
        this.name = comp.name;
    }
}


export class CompanyUpdateReq {
    name?: string;
    openingTimes: OpeningTimeCreateReq[] = []
    timezone?: number
    contacts: ContactPersonCreateReq[] = []
    logo?: string

    constructor(company?: CompanyDetailsRes) {
        if (company === undefined)
            return
        this.name = company.name;
        this.openingTimes = company.openingTimes.map(x => new OpeningTimeCreateReq(x));
        this.timezone = company.timezone;
        this.contacts = company.contactPerson.map(x => new ContactPersonCreateReq(x))
    }
}
